import { $, $$ } from 'donot';

export function strap(selector, fn) {
    // Check if an element-based selector exists, and if so execute the
    // function with that element as an argument
    const elements = $$(selector);

    if (!!elements.length) {
        elements.forEach(el => fn(el));
    }
}